<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          Установки <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Добавить новую
          <i v-on:click="newKit" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="false" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne"
             :default-sort="'initialDate'" :default-sort-direction="false"
             @update_top="updateTop"
             @resetNew="newOne = null"></big-one>

    <inv-select-modal :items="items" @close="closeSelectModal" @select="createNew">
    </inv-select-modal>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

const initialDate = {header: "Дата ввода", name: "initialDate", sort:true, direction: true, show: true};
const executingDate = {header: "Дата установки", name: "executingDate", sort:true, direction: true, show: true};

export default{
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {}
  },
  data() {
    return {
      content: [initialDate, executingDate],
      type: "kit",
      pageLimits: {contract: this.item.id},
      newOne: null,
      items: []
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    async newKit() {
      this.items = await this.$repo.getByURL('tsr/client/inv/' + this.item.client.id);
      await this.callSelectModal();
    },
    async createNew(idIndex) {
      let tsr = await this.$repo.get(idIndex.id, 'tsr');
      let object = {contract: this.item, tsr: tsr, id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
      await this.closeSelectModal();
    },
    updateTop() {
      this.$emit('update_top')
    },
    async callSelectModal() {
      let selectModal = await document.getElementById('INV_SELECT_MODAL');
      if (selectModal) {
        selectModal.style.display = "block";
      }
    },
    async closeSelectModal() {
      let selectModal = await document.getElementById('INV_SELECT_MODAL');
      if (selectModal) {
        selectModal.style.display = "none";
      }
    }
  }
}
</script>
<style>
</style>
